/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MapPinVM { 
    title?: string | null;
    description?: string | null;
    latitude?: number;
    longitude?: number;
    color?: string | null;
    id?: number;
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
    level4?: string | null;
    message1?: string | null;
    pinType?: string | null;
    isPublic?: boolean | null;
    hasReadingClub?: boolean | null;
    schoolType1?: string | null;
    schoolType2?: string | null;
    schoolLevel?: string | null;
    instituteType?: string | null;
    maleCount?: number | null;
    femaleCount?: number | null;
    learnerCount?: number | null;
    teacherCount?: number | null;
}

